import { render, staticRenderFns } from "./AthleteRanksResults.vue?vue&type=template&id=5c718e0a"
import script from "./AthleteRanksResults.vue?vue&type=script&lang=js"
export * from "./AthleteRanksResults.vue?vue&type=script&lang=js"
import style0 from "./AthleteRanksResults.vue?vue&type=style&index=0&id=5c718e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports